import { render, staticRenderFns } from "./GramContactApp.vue?vue&type=template&id=01e1c2ea"
import script from "./GramContactApp.vue?vue&type=script&lang=ts"
export * from "./GramContactApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports